import { useEffect } from 'react';
import { useMatch, useNavigate, Outlet } from 'react-router-dom';
import { Tabs, PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetAmlDictionariesQuery,
  useLazyGetAmlBaseCurrenciesQuery,
  useLazyGetAmlCurrenciesQuery,
} from '../../store/dictionaries/services';

import ROUTES from '../../routes';

import cn from './corporate-clients-risk.module.css';

const CorporateClientsRisk = () => {
  const match = useMatch(ROUTES.CORPORATE_CLIENTS_RISK);

  const navigate = useNavigate();

  const { activePermissions, currencies, riskScoreRanges, baseCurrency } =
    useAppSelector((state) => state.amlDictionaries);

  const [getDictionaries] = useLazyGetAmlDictionariesQuery();
  const [getAmlBaseCurrency] = useLazyGetAmlBaseCurrenciesQuery();
  const [getAmlCurrencies] = useLazyGetAmlCurrenciesQuery();

  useEffect(() => {
    if (match) {
      navigate(ROUTES.CORPORATE_CLIENTS_RISK_GEOGRAPHICAL);
    }
  }, [match]);

  useEffect(() => {
    if (!riskScoreRanges) {
      getDictionaries();
    }

    if (!currencies) {
      getAmlCurrencies();
    }

    if (!baseCurrency) {
      getAmlBaseCurrency();
    }
  }, [currencies, riskScoreRanges, baseCurrency]);

  useEffect(() => {
    let title = 'Corporate clients risk';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.corporateClientsRiskLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (!activePermissions.includes(PermissionEnum.SECTION_AML_KYC)) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.corporateClientsRisk}>
          <div className={cn.corporateClientsRiskTitle}>
            Corporate clients risk
          </div>
          <div className={cn.corporateClientsRiskTabsWrapper}>
            <Tabs
              itemClassName={cn.corporateClientsRiskTabItem}
              tabs={[
                {
                  name: 'Geographical risk',
                  path: ROUTES.CORPORATE_CLIENTS_RISK_GEOGRAPHICAL,
                },
                {
                  name: 'Volumes risk scores',
                  path: ROUTES.CORPORATE_CLIENTS_RISK_VOLUMES,
                },
                {
                  name: 'Product/Service risk',
                  path: ROUTES.CORPORATE_CLIENTS_RISK_PRODUCTS,
                },
                {
                  name: 'Delivery Channels',
                  path: ROUTES.CORPORATE_CLIENTS_RISK_DELIVERY_CHANNELS,
                },
                {
                  name: 'Date of Incorporation',
                  path: ROUTES.CORPORATE_CLIENTS_RISK_DATE_OF_INCORPORATION,
                },
                {
                  name: 'SIC codes',
                  path: ROUTES.CORPORATE_CLIENTS_RISK_SIC_CODES,
                },
              ]}
              enableRouting
            />
          </div>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default CorporateClientsRisk;
